import { useMutation, useQueryClient } from "@tanstack/react-query"
import { classes } from  '@shared/api/services'
import { toast } from "react-toastify"

export const useAddTeacherReview = () => {
	const queryClient = useQueryClient()

	const mutation = useMutation({
		mutationFn: (data) => classes.addTeacherReview(data.body, data.id),
    onSuccess: () => {
      queryClient.invalidateQueries(['alerts'])
			toast.success('Отзыв оставлен')
    },
  })

	return mutation
}